import moment from 'moment';
import * as React from 'react';
import {
  INPUT_DATE_FORMATS,
  mergeClasses,
  UTC_DATETIME_FORMAT,
} from '../constants';
import { TooltipPlacement } from '../types';
import LightTooltip from './LightTooltip';

type Props = {
  className?: string;
  date: string | moment.Moment;
  delay?: { show: number; hide: number };
  localFormat?: string;
  placement?: TooltipPlacement;
};

export default class LocalDate extends React.PureComponent<Props> {
  render() {
    const { className, date, delay, localFormat, placement } = this.props;
    const dateMoment = moment.isMoment(date)
      ? date
      : moment(date, INPUT_DATE_FORMATS);
    const local = dateMoment.local().format(localFormat || 'YYYY-MM-DD HH:mm');
    const utc = dateMoment.utc().format('[UTC: ]' + UTC_DATETIME_FORMAT);
    return (
      <LightTooltip tooltip={utc} delay={delay} placement={placement}>
        <span className={mergeClasses(['local-date', className])}>{local}</span>
      </LightTooltip>
    );
  }
}
